import { z } from "zod";
export const pushSubscriptionSchema = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
    userAgent: z.string().max(300).optional().nullable(),
});
export const unsubscribePushSchema = z.object({
    endpoint: z.string().url(),
});
//# sourceMappingURL=push.js.map